<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h1 class="mb-10">{{ dialogSettings.title }}</h1>
        <MessageTemplateForm
          ref="messageTemplateForm"
          :messageTemplate="messageTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        @click.native="onSubmit"
        :loading="isEditingOrganisationMessageTemplate"
      >
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_MESSAGE_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-message-templates";
import { copyState } from "@/utils/helpers";
import {
  EDIT_ORGANISATION_MESSAGE_TEMPLATE,
  FETCH_ORGANISATION_MESSAGE_TEMPLATES
} from "@/store/modules/organisations/organisation-message-templates/actions";
import MessageTemplateForm from "@/views/settings/components/message-templates/components/MessageTemplateForm";
import { getConvertedEmailBody } from "@/utils/conversations";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_MESSAGE_TEMPLATES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean,
    messageTemplate: Object
  },
  components: {
    PrimaryButton,
    DialogFull,
    MessageTemplateForm
  },
  computed: {
    ...mapState(copyState(["isEditingOrganisationMessageTemplate"])),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Edit Message Template"
      };
    }
  },
  methods: {
    ...mapActions({
      editMessageTemplate: EDIT_ORGANISATION_MESSAGE_TEMPLATE,
      fetchMessageTemplates: FETCH_ORGANISATION_MESSAGE_TEMPLATES
    }),
    async onSubmit() {
      const isFormValid = await this.$refs.messageTemplateForm.validateForm();
      if (isFormValid) {
        const { messageTemplateData } = this.$refs.messageTemplateForm;
        await this.editMessageTemplate({
          ...messageTemplateData,
          body: getConvertedEmailBody(messageTemplateData.body),
          id: this.messageTemplate.id
        });
        await this.$refs.messageTemplateForm.removeFiles();
        await this.$refs.messageTemplateForm.uploadNewFiles(
          this.messageTemplate.id
        );
        this.close();
      }
    },
    close() {
      this.fetchMessageTemplates();
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
